import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.d6s_1 = partyId;
        this.e6s_1 = playerId;
        this.f6s_1 = name;
        this.g6s_1 = email;
        this.h6s_1 = badge;
        this.i6s_1 = callSignAdjective;
        this.j6s_1 = callSignNoun;
        this.k6s_1 = imageURL;
        this.l6s_1 = avatarType;
        this.m6s_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.d6s_1.toString() + ', playerId=' + this.e6s_1.toString() + ', name=' + this.f6s_1 + ', email=' + this.g6s_1 + ', badge=' + this.h6s_1.toString() + ', callSignAdjective=' + this.i6s_1 + ', callSignNoun=' + this.j6s_1 + ', imageURL=' + toString(this.k6s_1) + ', avatarType=' + toString(this.l6s_1) + ', unvalidatedEmails=' + toString(this.m6s_1) + ')';
      }
      hashCode() {
        var result = this.d6s_1.hashCode();
        result = imul(result, 31) + this.e6s_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.f6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g6s_1) | 0;
        result = imul(result, 31) + this.h6s_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.i6s_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j6s_1) | 0;
        result = imul(result, 31) + hashCode(this.k6s_1) | 0;
        result = imul(result, 31) + hashCode(this.l6s_1) | 0;
        result = imul(result, 31) + hashCode(this.m6s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.d6s_1.equals(other.d6s_1))
          return false;
        if (!this.e6s_1.equals(other.e6s_1))
          return false;
        if (!(this.f6s_1 === other.f6s_1))
          return false;
        if (!(this.g6s_1 === other.g6s_1))
          return false;
        if (!this.h6s_1.equals(other.h6s_1))
          return false;
        if (!(this.i6s_1 === other.i6s_1))
          return false;
        if (!(this.j6s_1 === other.j6s_1))
          return false;
        if (!equals(this.k6s_1, other.k6s_1))
          return false;
        if (!equals(this.l6s_1, other.l6s_1))
          return false;
        if (!equals(this.m6s_1, other.m6s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
